<template>
    <Wait_Skeleton v-if="!IsWait" />
    <div class="formgrid grid " v-if="IsWait">
        <div class="col-12">
            <div class="col-6">
                <div class="grid">
                    <div class="col-6">
                        <InsanBedeni :pMusteri="pMusteri" />
                    </div>
                </div>
            </div>
            <div class="col-6">
                <!-- sağ bölüm -->
            </div>
        </div>
    </div>
    <div class="col-12">
        <IslemYapiliyor v-if="IslemYapiliyor" />
    </div>
    <div class="col-12 flex justify-content-end flex-wrap">
        <Button class="m-1" label="Tamam" icon="pi pi-check" iconPos="right" size="small" severity="success"
            @click="this.handleClick()" autofocus :disabled="IslemYapiliyor" v-if="!IslemYapiliyor" />
    </div>
</template>

<script>
// import GlobalServis from "../../../../../../../services/GlobalServis";
import InsanBedeni from "../VucutVerileri/InsanBedeni.vue";
export default {
    props: {
        pMusteri: Number
    },
    data() {
        return {
            IslemYapiliyor: false,
            IsWait: false,
            //

            //--------------
            // Validation Elements
            Valid: {

            }
        };
    },
    methods: {
        handleClick() {
            if (this._FormCheck()) { return; }
            this.IslemYapiliyor = true;
        }
    },
    _ResetForm() {
    },
    _FormCheck() {
        // let Check = false;
        // if (this.Isim === "") {
        //     this.Valid.Isim = true;
        //     this.$toast.add({ severity: "warn", summary: "Uyarı", detail: "Ünvan girin", life: 3000, });
        //     Check = true;
        //     return Check;
        // } else { this.Valid.Isim = false; Check = false; }

        // return Check;
    },
    created() {
        // this._GrupListesi();
        // this._MusteriInfo();

        this.IsWait = true;
    },
    components: {
        InsanBedeni
    },
};
</script>